import { ShippingMethod } from '@app/types/cart/ShippingMethod';
import { CartQueryShippingAddress } from '@app/types/monolith/types';
import { IntlShape } from '@redbubble/next/intl';
import { DeviceType } from '@redbubble/next/types';
import {
  ChangeResolveDetails,
  ExpressCheckoutPartialAddress,
  ShippingRate,
  StripeElements,
} from '@stripe/stripe-js';
import { trackGA4SelectShippingPreference } from '../../../pages/cart/utils/analytics';
import { StripeCart } from '../types';
import { updateModalAfterCartRefetch } from './utils';

// https://stripe.com/docs/js/elements_object/express_checkout_element_shippingratechange_event
export const handleShippingRateChange = async (
  shippingRate: ShippingRate,
  onShippingPreferenceChange: (
    shippingMethod: ShippingMethod,
    shippingAddress?: CartQueryShippingAddress
  ) => Promise<StripeCart>,
  elements: StripeElements,
  resolve: (resolveDetails?: ChangeResolveDetails) => void,
  reject: () => void,
  intl: IntlShape,
  isOrAbove: (deviceType: DeviceType) => boolean,
  shippingAddress?: ExpressCheckoutPartialAddress
): Promise<void> => {
  const address: CartQueryShippingAddress | undefined = shippingAddress && {
    countryCode: shippingAddress.country,
    postcode: shippingAddress.postal_code,
    state: shippingAddress.state,
  };
  const shippingMethod = shippingRate.id as ShippingMethod;

  onShippingPreferenceChange(shippingMethod, address)
    .then((cart) => {
      updateModalAfterCartRefetch(cart, elements, resolve, intl, isOrAbove);
    })
    .catch(() => {
      reject();
    })
    .finally(() => {
      trackGA4SelectShippingPreference({ shippingPreference: shippingMethod });
    });
};
